const MOUSE_FOCUS_CLASS = "mouse-focus";
const USING_KEYBOARD_CLASS = "using-keyboard";

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

/**
 * Makes the entire .mega-menu__image-caption-link card clickable
 * using the URL from data-card-link (set on the CTA link).
 * Uses event delegation so it works with InstantClick page transitions.
 * Clicks directly on <a> tags (e.g. the CTA itself) pass through normally.
 */
document.addEventListener('click', function(e) {
  var card = e.target.closest('[data-card-link]');
  if (!card) return;
  if (e.target.closest('a')) return;
  var url = card.getAttribute('data-card-link');
  if (card.hasAttribute('data-card-target')) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
});

/**
 * Makes the entire .product-wrap-container card clickable (mouse and keyboard Enter),
 * navigating to the URL of the .product-info__caption link inside it.
 * Clicks on interactive elements (a, button) inside the card pass through normally.
 * Uses event delegation so it works with InstantClick page transitions.
 */
function navigateProductCard(target) {
  var card = target.closest('.product-wrap-container');
  if (!card) return;
  var link = card.querySelector('.product-info__caption');
  if (link) window.location.href = link.href;
}

document.addEventListener('click', function(e) {
  if (e.target.closest('a, button')) return;
  navigateProductCard(e.target);
});

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Enter') return;
  if (e.target.closest('a, button')) return;
  var card = e.target.closest('.product-wrap-container');
  if (!card) return;
  e.preventDefault();
  navigateProductCard(e.target);
});

function handleFocusCssClasses() {
  let usingKeyboard = false;

  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab" || e.key.startsWith("Arrow")) {
      usingKeyboard = true;
      document.body.classList.add(USING_KEYBOARD_CLASS);
    }
  });

  document.addEventListener("mousedown", function () {
    usingKeyboard = false;
    document.body.classList.remove(USING_KEYBOARD_CLASS);
  });

  document.querySelectorAll("input, button, select, a").forEach((el) => {
    el.addEventListener("focus", function () {
      if (!usingKeyboard) {
        el.classList.add(MOUSE_FOCUS_CLASS);
      }
    });

    el.addEventListener("blur", function () {
      el.classList.remove(MOUSE_FOCUS_CLASS);
    });
  });
}